var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SerialPack',{attrs:{"url":_vm.url,"cur-class":"one_plus_six"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }